export default __webpack_public_path__ + "static/media/facebook-logo.b368108e.png";